export const useChatApi = () => {
  const session = useAuthSession()
  const config = useRuntimeConfig()
  return async (path, options = {}) => {
    await session.ensure()
    let token = session.read()?.token
    if (!token) throw Object.assign(new Error('ابتدا وارد حساب کاربری شوید.'), { statusCode: 401 })
    const request = () => $fetch(`/api/v1/chat${path}`, {
      baseURL: config.public.apiBaseUrl, retry: 0, timeout: 20000, cache: 'no-store',
      ...options, headers: { ...options.headers, Authorization: `Bearer ${token}` },
    })
    try { return await request() }
    catch (error) {
      if (Number(error?.statusCode ?? error?.status) !== 401) throw error
      token = await session.ensure({ force: true, rejectedToken: token })
      if (!token) throw error
      return request()
    }
  }
}
